/**
 * WCAG 2.1 §2.4.1 "Bypass Blocks": a keyboard user must be able to reach the
 * page content without tabbing through the whole sidebar on every navigation.
 *
 * Positioned by two plain rules in globals.css (`.skip-link`) rather than by
 * `sr-only focus:not-sr-only` or a `focus:` translate utility. The reason is
 * robustness, NOT a measured failure of those: Tailwind v4 hides `sr-only` with
 * `clip-path` and emits translation through the `translate` property, so both
 * recipes depend on a variant winning a cascade it does not obviously own.
 * Two unlayered rules depend on nothing.
 *
 * NOT VERIFIED IN A BROWSER, and it is the one thing here that could not be:
 * `:focus` only matches while the DOCUMENT has focus, and the automated pane
 * this was checked in reports `document.hasFocus() === false`, so no focus
 * style is observable from it at all. The hidden state and the accessible name
 * are verified; the focused appearance needs a human pressing Tab.
 */
export function SkipLink({ targetId = "main-content" }: { targetId?: string }) {
  return (
    <a
      href={`#${targetId}`}
      className="skip-link whitespace-nowrap rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-lg"
    >
      Skip to main content
    </a>
  );
}
